import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  paperContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  declinedPaper: {
    border: '1px solid #C43131'
  },
  notVerifiedPaper: {
    border: '1px solid #56420d'
  },
  declinedCaption: {
    color: palette.error.dark,
    fontWeight: '600',
    padding: '10px 18px',
    backgroundColor: palette.error.light,
    margin: '-24px -40px 24px -40px'
  },
  notVerifiedCaption: {
    color: palette.warning.dark,
    fontWeight: '600',
    padding: '10px 18px',
    backgroundColor: palette.warning.light,
    margin: '-24px -40px 24px -40px'
  },
  method: {
    display: 'flex',
    alignItems: 'center',
    [breakpointsFunc.breakpoints.down('md')]: {
      marginBottom: '24px'
    }
  },
  methodDetails: {
    marginLeft: '20px'
  },
  isAutoPay: {
    backgroundColor: palette.success.light,
    color: palette.success.dark,
    '& path': {
      fill: palette.success.main
    },
    '&:hover': {
      backgroundColor: palette.success.light,
      '& path': {
        fill: palette.success.main
      }
    }
  },
  actions: {
    display: 'flex',
    marginLeft: '40px',
    '& .modal-trigger': {
      margin: '0 10px'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      marginLeft: '0'
    }
  },
  accordionWrapper: {
    margin: '24px -40px -24px -40px'
  },
  accordion: {
    boxShadow: 'none',
    '&.Mui-expanded': {
      margin: '0'
    },
    '& .MuiAccordionSummary-root': {
      background: palette.gradients.white,
      flexDirection: 'row-reverse',
      minHeight: '84px',
      padding: '0 32px'
    },
    '& .MuiCollapse-root': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  accordionContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between'
  },
  accordionDetails: {
    padding: '24px 74px'
  }
});
export default useStyles;